import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import './styles/BookShelf.css';
import arbookimage from '../../assets/pageimages/ARBook.webp';
// import adImage from '../../assets/pageimages/bookworldlistad.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';

const ARBookHome = () => {
    return (
        <MainLayout>
            <div className="bg-gradient-to-r from-teal-500 via-cyan-600 to-blue-700 min-h-screen p-4 sm:p-8">
                {/* Heading Section */}
                <div className="text-center mb-8">
                    <h3 className='text-lg sm:text-xl font-bold text-white border-b border-b-gray-300 pb-2 mx-4'>
                        Learnings - ARBooks
                    </h3>
                </div>

                {/* ARBooks Image Section */}
                <div className="flex justify-center mb-8">
                    <img
                        src={arbookimage}
                        alt="AR Books"
                        className="w-3/4 sm:w-1/2 rounded-lg shadow-lg"
                    />
                </div>

                {/* Dashboard Button */}
                <div className="flex justify-center mt-8">
                    <Link 
                        to='/dashboard' 
                        className='flex items-center justify-center w-4/5 sm:w-2/4 h-12 sm:h-16 text-lg sm:text-2xl font-semibold text-white bg-blue-600 rounded-lg shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring focus:ring-blue-500'
                    >
                        <FontAwesomeIcon className="mr-2 sm:mr-4" icon={faBook} />  
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        </MainLayout>
    );
};

export default ARBookHome;
